document.addEventListener("DOMContentLoaded", () => {
    const megaMenuToggles = document.querySelectorAll(".mega-menu-toggle");

    const globalNav = document.getElementById("global-nav");

    if (!globalNav) {
        return;
    }

    const backdrop = document.createElement("div");

    backdrop.className = "mega-menu-backdrop";
    backdrop.hidden = true;
    backdrop.setAttribute("aria-hidden", "true");

    globalNav.appendChild(backdrop);

    const updateBackdrop = () => {
        const hasOpenMenu = globalNav.querySelector(
            '.mega-menu[aria-hidden="false"]'
        ) !== null;

        backdrop.hidden = !hasOpenMenu;

        if (!hasOpenMenu) {
            return;
        }

        const top = Math.max(
            0,
            globalNav.getBoundingClientRect().bottom
        );

        backdrop.style.setProperty(
            "--mega-menu-backdrop-top",
            `${top}px`
        );
    };

    const dismissMegaMenu = () => {
        const activeToggle = globalNav.querySelector(
            '.mega-menu-toggle[aria-expanded="true"]'
        );

        closeAllMegaMenus();
        activeToggle?.focus({ preventScroll: true });
    };

    document.addEventListener("click", (event) => {
        if (backdrop.hidden || !(event.target instanceof Element)) {
            return;
        }

        const clickedBackdrop = backdrop.contains(event.target);
        const clickedOutsideNav = !globalNav.contains(event.target);

        if (clickedBackdrop || clickedOutsideNav) {
            dismissMegaMenu();
            return;
        }

        // Klick inne i megamenyn eller på menyknappar/länkar
        // ska hanteras som vanligt.
        if (event.target.closest(".mega-menu, a, button")) {
            return;
        }

        // Använd koordinater endast för mus-/touchklick.
        if (event.detail === 0) {
            return;
        }

        const lastMenuLink = globalNav.querySelector(
            ".navbar-nav > li:last-child > .nav-link"
        );

        if (!lastMenuLink) {
            return;
        }

        const navRect = globalNav.getBoundingClientRect();
        const lastLinkRect = lastMenuLink.getBoundingClientRect();

        const clickedRightOfLastButton =
            event.clientX > lastLinkRect.right &&
            event.clientX <= navRect.right &&
            event.clientY >= navRect.top &&
            event.clientY <= navRect.bottom;

        if (clickedRightOfLastButton) {
            dismissMegaMenu();
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && !backdrop.hidden) {
            event.preventDefault();
            dismissMegaMenu();
        }
    });

    const getPanelFromButton = (button) => {
        if (!button) {
            return null;
        }

        const panelId = button.getAttribute("aria-controls");

        return panelId
            ? document.getElementById(panelId)
            : null;
    };

    const getPanelFromItem = (item) => {
        if (!item) {
            return null;
        }

        const button = item.querySelector(":scope > .mega-menu-next");

        return getPanelFromButton(button);
    };

    const closePanelContents = (panel) => {
        if (!panel) {
            return;
        }

        panel.setAttribute("aria-hidden", "true");

        panel
            .querySelectorAll(".mega-menu-next")
            .forEach(button => {
                button.setAttribute("aria-expanded", "false");
            });

        panel
            .querySelectorAll("[data-mega-menu-panel]")
            .forEach(childPanel => {
                childPanel.setAttribute("aria-hidden", "true");
            });

        panel
            .querySelectorAll("[data-mega-menu-item]")
            .forEach(item => {
                item.classList.remove("is-active");
            });
    };

    const updateMegaMenuViewportHeight = (megaMenu) => {
        if (!megaMenu) {
            return;
        }

        const top = megaMenu.getBoundingClientRect().top;
        const availableHeight = window.innerHeight - Math.max(top, 0);

        megaMenu.style.setProperty(
            "--mega-menu-max-height",
            `${availableHeight}px`
        );
    };

    const updateOpenMegaMenusViewportHeight = () => {
        document
            .querySelectorAll('.mega-menu[aria-hidden="false"]')
            .forEach(megaMenu => {
                updateMegaMenuViewportHeight(megaMenu);
            });

        updateBackdrop();
    };

    window.addEventListener("resize", updateOpenMegaMenusViewportHeight);
    window.addEventListener("scroll", updateOpenMegaMenusViewportHeight);

    const updateMegaMenuHeight = (megaMenu) => {
        if (!megaMenu) {
            return;
        }

        // Ta bort tidigare gemensam höjd så att listorna
        // återgår till sin naturliga höjd innan vi mäter.
        megaMenu.style.removeProperty("--mega-menu-content-height");

        const rootList = megaMenu.querySelector(
            ":scope > .mega-menu-content > .mega-menu-column > .mega-menu-list"
        );

        const visiblePanelLists = [
            ...megaMenu.querySelectorAll(
                '[data-mega-menu-panel][aria-hidden="false"] > .mega-menu-column > .mega-menu-list'
            )
        ];

        const visibleLists = [
            rootList,
            ...visiblePanelLists
        ].filter(Boolean);

        if (!visibleLists.length) {
            return;
        }

        const maxHeight = Math.max(
            ...visibleLists.map(list => list.scrollHeight)
        );

        megaMenu.style.setProperty(
            "--mega-menu-content-height",
            `${maxHeight}px`
        );
    };

    const updateMegaMenuDepth = (megaMenu) => {
        if (!megaMenu) {
            return;
        }

        const openPanels = megaMenu.querySelectorAll(
            '[data-mega-menu-panel][aria-hidden="false"]'
        );

        const hasFourLevels = openPanels.length >= 3;

        if (hasFourLevels) {
            const rootList = megaMenu.querySelector(
                ":scope > .mega-menu-content > .mega-menu-column > .mega-menu-list"
            );

            const activeRootItem = rootList?.querySelector(
                ":scope > .mega-menu-item.is-active"
            );

            const firstOpenPanel = getPanelFromItem(activeRootItem);

            const firstChildList = firstOpenPanel?.querySelector(
                ":scope > .mega-menu-column > .mega-menu-list"
            );

            if (firstChildList) {
                megaMenu.style.setProperty(
                    "--mega-menu-root-height",
                    `${firstChildList.scrollHeight}px`
                );
            }
        }

        megaMenu.classList.toggle(
            "has-four-levels",
            hasFourLevels
        );

        if (!hasFourLevels) {
            megaMenu.style.removeProperty("--mega-menu-root-height");
        }
    };

    const closeMegaMenu = (megaMenu) => {
        if (!megaMenu) {
            return;
        }

        megaMenu.querySelectorAll(".mega-menu-list").forEach(list => {
            list.scrollTop = 0;
        });

        megaMenu.setAttribute("aria-hidden", "true");

        const toggle = document.querySelector(
            `.mega-menu-toggle[aria-controls="${megaMenu.id}"]`
        );

        if (toggle) {
            toggle.setAttribute("aria-expanded", "false");
        }

        megaMenu
            .querySelectorAll(".mega-menu-next")
            .forEach(button => {
                button.setAttribute("aria-expanded", "false");
            });

        megaMenu
            .querySelectorAll("[data-mega-menu-panel]")
            .forEach(panel => {
                panel.setAttribute("aria-hidden", "true");
            });

        megaMenu
            .querySelectorAll("[data-mega-menu-item]")
            .forEach(item => {
                item.classList.remove("is-active");
            });

        megaMenu.classList.remove("has-four-levels");
        megaMenu.style.removeProperty("--mega-menu-root-height");
        megaMenu.style.removeProperty("--mega-menu-content-height");
        megaMenu.style.removeProperty("--mega-menu-max-height");

        updateBackdrop();
    };

    const closeAllMegaMenus = (exceptId = null) => {
        document.querySelectorAll(".mega-menu").forEach(megaMenu => {
            if (megaMenu.id !== exceptId) {
                closeMegaMenu(megaMenu);
            }
        });
    };

    // Öppna/stäng hela megamenyn
    megaMenuToggles.forEach(toggle => {
        toggle.addEventListener("click", (event) => {
            event.preventDefault();

            const megaMenuId = toggle.getAttribute("aria-controls");
            const megaMenu = document.getElementById(megaMenuId);

            if (!megaMenu) {
                return;
            }

            const isOpen =
                toggle.getAttribute("aria-expanded") === "true";

            closeAllMegaMenus(megaMenuId);

            if (isOpen) {
                closeMegaMenu(megaMenu);
                return;
            }

            toggle.setAttribute("aria-expanded", "true");
            megaMenu.setAttribute("aria-hidden", "false");

            updateMegaMenuViewportHeight(megaMenu);
            updateMegaMenuHeight(megaMenu);
            updateBackdrop();
        });
    });

    const getSiblingItems = (currentItem, megaMenu) => {
        const rootList = megaMenu.querySelector(
            ":scope > .mega-menu-content > .mega-menu-column > .mega-menu-list"
        );

        if (!rootList) {
            return [];
        }

        const parentPanel =
            currentItem.closest("[data-mega-menu-panel]");

        // Ingen parent-panel = vänstra/root-kolumnen.
        // Vanliga ämnen och ExtraMenu-länkar räknas som siblings.
        if (!parentPanel) {
            return [
                ...rootList.querySelectorAll(
                    ":scope > [data-mega-menu-item]"
                ),
                ...rootList.querySelectorAll(
                    ":scope > .mega-menu-extra-menu > .mega-menu-extra-menu-list > [data-mega-menu-item]"
                )
            ];
        }

        // På nivå 2+ använder vi items från samma lista.
        const currentList = currentItem.closest(".mega-menu-list");

        return currentList
            ? [
                ...currentList.querySelectorAll(
                    ":scope > [data-mega-menu-item]"
                )
            ]
            : [];
    };

    // Öppna/stäng nivåer inne i megamenyn
    document.querySelectorAll(".mega-menu-next").forEach(button => {
        button.addEventListener("click", () => {
            const panel = getPanelFromButton(button);

            if (!panel) {
                return;
            }

            const currentItem =
                button.closest("[data-mega-menu-item]");

            const megaMenu =
                button.closest(".mega-menu");

            if (!currentItem || !megaMenu) {
                return;
            }

            const siblingItems =
                getSiblingItems(currentItem, megaMenu);

            const isOpen =
                button.getAttribute("aria-expanded") === "true";

            siblingItems.forEach(item => {
                if (item === currentItem) {
                    return;
                }

                item.classList.remove("is-active");

                const siblingButton =
                    item.querySelector(":scope > .mega-menu-next");

                if (!siblingButton) {
                    return;
                }

                siblingButton.setAttribute(
                    "aria-expanded",
                    "false"
                );

                const siblingPanel =
                    getPanelFromButton(siblingButton);

                closePanelContents(siblingPanel);
            });

            if (isOpen) {
                currentItem.classList.remove("is-active");

                button.setAttribute(
                    "aria-expanded",
                    "false"
                );

                closePanelContents(panel);

                updateMegaMenuDepth(megaMenu);
                updateMegaMenuHeight(megaMenu);

                return;
            }

            currentItem.classList.add("is-active");

            button.setAttribute(
                "aria-expanded",
                "true"
            );

            panel.setAttribute(
                "aria-hidden",
                "false"
            );

            updateMegaMenuDepth(megaMenu);
            updateMegaMenuHeight(megaMenu);
        });
    });
});